// Game sound effects - lightweight inline audio
const AudioCtx = window.AudioContext || window.webkitAudioContext;
let ctx = null;
let soundEnabled = true;

function getCtx() {
  if (!ctx) ctx = new AudioCtx();
  return ctx;
}

function beep(freq, duration, type = "sine", vol = 0.15) {
  if (!soundEnabled) return;
  try {
    const c = getCtx();
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    gain.gain.value = vol;
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration);
    osc.connect(gain);
    gain.connect(c.destination);
    osc.start(c.currentTime);
    osc.stop(c.currentTime + duration);
  } catch {}
}

export const GameSounds = {
  toggle: (on) => { soundEnabled = on; },
  isEnabled: () => soundEnabled,

  // Collect resources - cheerful rising arpeggio
  collect: () => {
    beep(523, 0.1, "sine", 0.12);
    setTimeout(() => beep(659, 0.1, "sine", 0.12), 80);
    setTimeout(() => beep(784, 0.15, "sine", 0.15), 160);
    setTimeout(() => beep(1047, 0.2, "sine", 0.1), 260);
  },

  // Deploy workers - low power-up hum
  deploy: () => {
    beep(130, 0.3, "sawtooth", 0.08);
    setTimeout(() => beep(200, 0.2, "sawtooth", 0.1), 150);
    setTimeout(() => beep(330, 0.3, "sine", 0.12), 300);
  },

  // Buy/purchase - coin drop
  purchase: () => {
    beep(880, 0.08, "sine", 0.15);
    setTimeout(() => beep(1100, 0.08, "sine", 0.12), 60);
    setTimeout(() => beep(1320, 0.12, "sine", 0.1), 120);
  },

  // Click / button press
  click: () => {
    beep(600, 0.05, "square", 0.06);
  },

  // Error / fail
  error: () => {
    beep(200, 0.15, "sawtooth", 0.1);
    setTimeout(() => beep(150, 0.2, "sawtooth", 0.08), 120);
  },

  // Daily reward claim - celebration
  reward: () => {
    beep(523, 0.1, "sine", 0.12);
    setTimeout(() => beep(659, 0.1, "sine", 0.12), 100);
    setTimeout(() => beep(784, 0.1, "sine", 0.12), 200);
    setTimeout(() => beep(1047, 0.15, "sine", 0.15), 300);
    setTimeout(() => beep(1318, 0.25, "sine", 0.12), 420);
  },

  // Upgrade stat
  upgrade: () => {
    beep(440, 0.1, "triangle", 0.1);
    setTimeout(() => beep(660, 0.15, "triangle", 0.12), 100);
    setTimeout(() => beep(880, 0.2, "sine", 0.1), 220);
  },

  // Recall workers
  recall: () => {
    beep(440, 0.15, "sine", 0.1);
    setTimeout(() => beep(330, 0.15, "sine", 0.1), 120);
    setTimeout(() => beep(220, 0.2, "sine", 0.08), 240);
  },
};

export default GameSounds;
